const isArray = Array.isArray

const isString = (val) => typeof val === 'string'

const isObject = (val) => val !== null && typeof val === 'object'

function classNames(...args: any[]) {
  const classes = []
  for (let i = 0; i < args.length; i++) {
    const value = args[i]
    if (!value) continue
    if (isString(value)) {
      // @ts-ignore
      classes.push(value)
    } else if (isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        const inner = classNames(value[i])
        if (inner) {
          // @ts-ignore
          classes.push(inner)
        }
      }
    } else if (isObject(value)) {
      for (const name in value) {
        if (value[name]) {
          // @ts-ignore
          classes.push(name)
        }
      }
    }
  }
  return classes.join(' ')
}

export default classNames
